import React from 'react';

export default function CopyIcon({ className = '', title }) {
  return (
<svg
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  aria-hidden="true"
  className={className}
>
  <path
    d="M1.99948 5.00098C2.55177 5.00098 2.99948 5.44869 2.99948 6.00098V14.001H8.99948C9.55177 14.001 9.99948 14.4487 9.99948 15.001C9.99925 15.5531 9.55162 16.001 8.99948 16.001H2.99948C1.89523 16.0008 0.999716 15.1052 0.999481 14.001V6.00098C0.999481 5.44882 1.44737 5.00118 1.99948 5.00098ZM11.0385 0.00195312C11.0477 0.00230574 11.0568 0.00232823 11.0659 0.00292969C11.1578 0.00890232 11.2461 0.0275063 11.3296 0.0566406C11.3338 0.0581337 11.338 0.0599716 11.3423 0.0615234C11.4288 0.0930782 11.51 0.135572 11.5835 0.188477C11.5902 0.193336 11.5963 0.199061 11.603 0.204102C11.6395 0.231791 11.6751 0.260623 11.7075 0.292969L14.7075 3.29297C14.7395 3.32499 14.7679 3.36037 14.7954 3.39648C14.8003 3.40298 14.8053 3.40942 14.81 3.41602C14.8608 3.48631 14.9027 3.56313 14.9341 3.64551C14.9383 3.6566 14.9429 3.66749 14.9467 3.67871C14.9742 3.75954 14.9907 3.84496 14.9966 3.93359C14.9972 3.9427 14.9972 3.95181 14.9975 3.96094C14.998 3.97392 15.0005 3.9869 15.0005 4V11C15.0005 11.5522 14.5526 11.9998 14.0005 12H6.00046C5.44817 12 5.00046 11.5523 5.00046 11V1C5.0007 0.44792 5.44832 0 6.00046 0H11.0005C11.0132 4.89023e-06 11.0259 0.0014743 11.0385 0.00195312ZM7.00046 10H13.0005V5H11.0005C10.4482 5 10.0005 4.55228 10.0005 4V2H7.00046V10Z"
    fill="currentColor"
  />
</svg>
  );
}
